import { CodeBlock } from './CodeBlock'
import { ColorBlock } from './ColorBlock'
import { LocalLink } from './LocalLink'
import { Mention } from './Mention'
import { Emoji } from './Emoji'
import { Image } from './Image'
import { File } from './File'
import { ImageChat } from './ImageChat'
import { Gif } from './Gif'
import { Placeholder } from './Placeholder'
import { ListItem } from './ListItem'
import { TaskItem } from './TaskItem'
import { TaskList } from './TaskList'
import { TextColor } from './TextColor'
import { TrailingNode } from './TrailingNode'
import { Title } from './Title'
import { CustomDoc } from './CustomDoc'
import { CommentMark } from './CommentMark'
import { CommentNode } from './CommentNode'
import { Scroll } from './Scroll'
import { Table } from './Table'
import { TableCell } from './TableCell'
import { TableHeader } from './TableHeader'
import { Indent } from './Indent'
import { Paragraph } from './Paragraph'
import { Heading } from './Heading'
import { Blockquote } from './Blockquote'
import { Typography } from './Typography'
import { AddTemplateButton } from './AddTemplateButton'
import { Chat } from './Chat'
import { OrderedList } from './OrderedList'
import { OrderedListItem } from './OrderedListItem'
import { ImageChatEmoji } from './ImageChatEmoji'
import { Link } from './Link'

import BulletList from '@tiptap/extension-bullet-list'
import Bold from '@tiptap/extension-bold'
import Dropcursor from '@tiptap/extension-dropcursor'
import Gapcursor from '@tiptap/extension-gapcursor'
import HardBreak from '@tiptap/extension-hard-break'
import HorizontalRule from '@tiptap/extension-horizontal-rule'
import Italic from '@tiptap/extension-italic'
// import Link from '@tiptap/extension-link'
import Highlight from '@tiptap/extension-highlight'
// import OrderedList from '@tiptap/extension-ordered-list'
import Underline from '@tiptap/extension-underline'
import Text from '@tiptap/extension-text'
import TableRow from '@tiptap/extension-table-row'
import Document from '@tiptap/extension-document'
import History from '@tiptap/extension-history'

export const defaultExtensions = (options) => {
  return [
    CommentMark,
    Indent,

    // default extensions
    Dropcursor.configure(options?.dropcursor),
    Gapcursor,
    // custom extension
    Paragraph,
    Text,
    Bold.configure(options?.bold),
    Italic.configure(options?.italic),
    CodeBlock.configure(options?.codeBlock),
    HardBreak.configure(options?.hardBreak),
    HorizontalRule.configure(options?.horizontalRule),
    BulletList.configure(options?.bulletList),
    OrderedList.configure(options?.orderedList),
    OrderedListItem.configure(options?.orderedListItem),
    Highlight.configure(options?.highlight),
    History.configure(options?.history),
    Typography,

    // custom extensions
    Blockquote,
    Heading,
    TextColor,
    TrailingNode,
    Placeholder,
    ColorBlock,
    Underline,
    ListItem.configure(options?.listItem),
    Link,
    LocalLink,
    Mention.configure(options?.mention),
    Emoji.configure(options?.emoji),
    Image.configure(options?.image),
    File.configure(options?.file),
    Gif,
    TaskItem.configure(options?.taskItem),
    TaskList,
    Title,
    CustomDoc,
    CommentNode,
    Scroll,
    Table,
    TableRow,
    TableHeader,
    TableCell,
    AddTemplateButton
  ]
}

export const chatExtensions = (options) => {
  return [
    Document,
    Paragraph,
    HardBreak.configure(options?.hardBreak),
    Text,
    Bold.configure(options?.bold),
    Italic.configure(options?.italic),
    Highlight.configure(options?.highlight),
    Typography,
    // custom extensions
    Blockquote,
    Placeholder,
    Underline,
    Link,
    LocalLink,
    Mention.configure(options?.mention),
    Emoji.configure(options?.emoji),
    ImageChat.configure(options?.image),
    Gif,
    Chat.configure(options?.chat),
    ImageChatEmoji
  ]
}

export const taskExtensions = (options) => {
  return [
    Document,
    Paragraph,
    HardBreak.configure(options?.hardBreak),
    Text,
    Bold.configure(options?.bold),
    Italic.configure(options?.italic),
    Highlight.configure(options?.highlight),
    Typography,
    // custom extensions
    Blockquote,
    Placeholder,
    Underline,
    Link,
    LocalLink,
    Mention.configure(options?.mention),
    Emoji.configure(options?.emoji),
    Image.configure(options?.image),
    File.configure(options?.file),
    Gif,
    ImageChatEmoji
  ]
}
